import React from 'react';
import ReactDOM from 'react-dom';
import RedshelfApolloClient from '@redshelf/redshelf-data';
import { AppProvider } from '@redshelf/redshelf-ui';

import reportWebVitals from './reportWebVitals';
import routes from './routes';

const environment = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV;

ReactDOM.render(
  <React.StrictMode>
    <RedshelfApolloClient environment={environment}>
      <AppProvider RouterProps={{ routes }} />
    </RedshelfApolloClient>
  </React.StrictMode>,
  document.getElementById('root'),
);

// TODO: Revisit this when talk about analytics/GTM
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
